import React, { FunctionComponent } from "react";
import classNames from "classnames";

import "./ContentSectionWrapper.scss";

interface ContentSectionWrapperProps {
    sectionTitle: string;
    className?: string;
}

const ContentSectionWrapper: FunctionComponent<ContentSectionWrapperProps> = props => {
    return (
        <div className={classNames("section-wrapper-component", props.className)}>
            <h2 className="section-wrapper-header sectiontitle">{props.sectionTitle}</h2>
            {props.children}
        </div>
    );
};

export default ContentSectionWrapper;
